import { useAppSelector } from "redux/hooks";

const useLoading = (): boolean => {
  const loginLoading = useAppSelector((state) => state.login.loading);
  const otpLoading = useAppSelector((state) => state.otp.loading);
  const merchantLoading = useAppSelector((state) => state.merchant.loading);
  const PassRefPersonelInfoLoading = useAppSelector(
    (state) => state.PassRefPersonelInfo.loading
  );
  const PassRefCardInfoLoading = useAppSelector(
    (state) => state.PassRefCardInfo.loading
  );
  const merchantSwitchLoading = useAppSelector(
    (state) => state.merchantSwitch.loading
  );
  const employeeLoading = useAppSelector((state) => state.employee.loading);
  const employeeManagementLoading = useAppSelector(
    (state) => state.employeeManagement.loading
  );
  const authListLoading = useAppSelector((state) => state.authList.loading);
  const integratorListLoading = useAppSelector(
    (state) => state.IntegratorList.loading
  );

  return (
    loginLoading ||
    otpLoading ||
    merchantLoading ||
    merchantSwitchLoading ||
    employeeLoading ||
    employeeManagementLoading ||
    authListLoading ||
    integratorListLoading ||
    PassRefPersonelInfoLoading ||
    PassRefCardInfoLoading
  );
};

export default useLoading;
